import { render, staticRenderFns } from "./salesPriceChart.vue?vue&type=template&id=021bd1e5&"
import script from "./salesPriceChart.vue?vue&type=script&lang=js&"
export * from "./salesPriceChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports